export const MIN_HIGH_RATING_VALUE = 4;
